module.exports = __webpack_public_path__ + "img/background_main.eb53772c.svg";